import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../../../components/Icon';

const FlightFuelIcon = ({ fuelCharge, className }) => (
  <Icon
    className={className}
    type={fuelCharge > 0 ? 'fuel-white' : 'fuel-green'}
  />
);

FlightFuelIcon.defaultProps = {
  fuelCharge: 0,
  className: null,
};

FlightFuelIcon.propTypes = {
  fuelCharge: PropTypes.number,
  className: PropTypes.string,
};

export default FlightFuelIcon;
